import { OptionSheetError } from '@frontend/web/errorPages';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/option-sheet/$optionSheetId/')({
  errorComponent: OptionSheetError,
});
